import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-eye-icon',
  template: `<svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.12"
      d="M10.334 12.5C11.7147 12.5 12.834 11.3807 12.834 10C12.834 8.61929 11.7147 7.5 10.334 7.5C8.95327 7.5 7.83398 8.61929 7.83398 10C7.83398 11.3807 8.95327 12.5 10.334 12.5Z"
      fill="black"
    />
    <path
      d="M2.35075 10.5943C2.23726 10.4146 2.18052 10.3248 2.14875 10.1862C2.12489 10.0821 2.12489 9.91791 2.14875 9.81381C2.18052 9.67522 2.23726 9.58537 2.35075 9.40567C3.28859 7.92069 6.08015 4.16666 10.3343 4.16666C14.5885 4.16666 17.38 7.92069 18.3179 9.40567C18.4314 9.58537 18.4881 9.67522 18.5199 9.81381C18.5437 9.91791 18.5437 10.0821 18.5199 10.1862C18.4881 10.3248 18.4314 10.4146 18.3179 10.5943C17.38 12.0793 14.5885 15.8333 10.3343 15.8333C6.08015 15.8333 3.28859 12.0793 2.35075 10.5943Z"
      [attr.stroke]="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.3343 12.5C11.715 12.5 12.8343 11.3807 12.8343 9.99999C12.8343 8.61928 11.715 7.49999 10.3343 7.49999C8.95361 7.49999 7.83432 8.61928 7.83432 9.99999C7.83432 11.3807 8.95361 12.5 10.3343 12.5Z"
      stroke="#64748B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg> `,
})
export class EyeIcon extends BaseIconComponent {}
